import classNames from "classnames";
import type { Ref } from "react";
import styles from "./AnimatedSearchIcon.module.scss";

interface SearchIconProps {
    size?: number;
    className?: string;
    isAnimating?: boolean;
}

export const AnimatedSearchIcon = ({
    className,
    size = 16,
    isAnimating = false,
    ref,
}: SearchIconProps & { ref?: Ref<HTMLDivElement> }) => (
    <div
        ref={ref}
        className={classNames(
            styles.icon,
            isAnimating && styles.animating,
            className,
        )}
    >
        <svg
            fill="none"
            height={size}
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            width={size}
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.3-4.3" />
        </svg>
    </div>
);
